"use strict";
exports.__esModule = true;
exports.isNodeEnv = function () {
    return typeof process !== "undefined" && process.version;
};
//# sourceMappingURL=Utilities.js.map